export default __webpack_public_path__ + "static/mission_girl-9cd7df0b4621c906cf7bffddf8403f2d.png";